
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[topicSlug]/[courseSlug]",
      function () {
        return require("private-next-pages/courses/[topicSlug]/[courseSlug]/index.tsx");
      }
    ]);
  